// src/routes/cases/components/Simulations.jsx
import { useContext, useState, useEffect, useRef } from "react";
import { FiEdit, FiUpload } from "react-icons/fi";
import { MdEditNote } from "react-icons/md";
import { MdDeleteOutline } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import { GrView } from "react-icons/gr";
import DataTable from "react-data-table-component";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import { IoIosClose } from "react-icons/io";
import Lightbox from "yet-another-react-lightbox";
import { CaseService } from "../../../api/CaseService";
import ReactQuill from "react-quill";

import "react-quill/dist/quill.snow.css";
import "yet-another-react-lightbox/styles.css";
import { AuthContext } from "../../../components/authcontext/AuthContext";

const Simulations = ({ caseId = 0 }) => {

  // Case IPR Chart Zip Upload Start
  const casePlanUploadRef = useRef();
  const [selectedRowForUpload, setSelectedRowForUpload] = useState(null);
  const [progress, setProgress] = useState(0);

  // Case IPR Chart Zip Upload End
  const [casee, setCasee] = useState({});
  const { currentUser } = useContext(AuthContext);
  const userType = currentUser?.roles[0]?.name;
  const permissions = currentUser?.permissions;

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [casetab, setCasetab] = useState("plans");
  const [plansColumns, setPlansColumns] = useState([]);

  const [idd, setIdd] = useState("");
  const [plan, setPlan] = useState([]);
  const [dataa, setDataa] = useState([]);
  const [inputs, setInputs] = useState([
    { ipr_chart: null, simulation_link_url: "", text_notes: "" },
  ]);

  const handleCasePlanUploadClick = (row) => {
    setSelectedRowForUpload(row);
    casePlanUploadRef.current?.click();
  };

  const handleCasePlanUpload = async (event) => {

    const file = event?.target?.files[0];
    const casePlanId = selectedRowForUpload?.id;

    if (!file || !casePlanId) {
      toast.error('No File Selected!', {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
      });
      return;
    }

    const isZip = file.type === "application/zip" || file.name.endsWith(".zip");
    const maxMB = 100;
    const maxSize = maxMB * 1024 * 1024; // 100 MB

    if (!isZip) {
      toast.error('Only ZIP Files Allowed!', {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
      });
      return;
    }

    // if (file.size > maxSize) {
    //   toast.error(`Max File Size ${maxMB} MBs!`, {
    //     autoClose: 2000,
    //     pauseOnHover: true,
    //     draggable: true,
    //   });
    //   return;
    // }

    try {

      var formData = new FormData();

      setLoading(true);
      setProgress(0);

      formData.append("ipr_chart_zip", file);

      const result = await CaseService.casePlanZipUpload(casePlanId, formData, (progressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        setProgress(percentCompleted);
      });

      if (result?.data?.status === 200) {
        toast.success(result?.data?.message, {
          autoClose: 1000,
          pauseOnHover: true,
          draggable: true,
        });

      } else {

        toast.error(result?.data?.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
        });

      }

    } catch (error) {

      toast.error(error?.response?.data?.errors?.[0] || 'An error occurred', {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
      });

    } finally {

      setLoading(false);
      setProgress(0);
      if (casePlanUploadRef.current) {
        casePlanUploadRef.current.value = null;
      }

    }

  };
  
  //get case details
  const getCaseDetailFunction = async (id) => {
    try {
      const result = await CaseService.getCaseDetail(id);

      if (result?.data?.status == 200) 
      {
        setCasee(result?.data?.data);

        const transformedUsers = result?.data?.data?.case_plans?.map((item, index) => ({
          id: item?.guid,
          planId: index + 1,
          caseId: result?.data?.data?.case_id,
          iprChart: item?.ipr_chart,
          textNotes: item?.text_notes,
          zipFile: item?.zip_file,
          containerFile: item?.container_file,
          simulationLink: item?.simulation_link_url,
        }));

        setDataa(transformedUsers);
      }
      else {
        if (result?.data?.message == "Unauthenticated.") {
          navigate('/login')
        }
        toast.error(result?.data?.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
        });
      }
    } catch (error) {
      toast.error(error?.result?.data?.errors[0], {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  //set edit plan
  const setEditPlan = (row) => {
    setIdd(row.id);
    setInputs([{ ipr_chart: row.iprChart, simulation_link_url: row.simulationLink, text_notes: row.textNotes }])
    setCasetab("edit");
  };

  const setViewPlan = (idd) => {
    setIdd(idd);
    setCasetab("view");
    getPlan(idd)
  };

  // view plan details
  const getPlan = async (idd) => {
    try {
      const result = await CaseService.getCasePlan(idd);

      if (result?.data?.status == 200) {
        setPlan(result?.data?.data);

        setInputs([{ 
          ipr_chart: result?.data?.data?.ipr_chart,
          text_notes: result?.data?.data?.text_notes,
          simulation_link_url: result?.data?.data?.simulation_link_url,
        }]);

      } else {
        if (result?.data?.message == "Unauthenticated.") {
          navigate("/login");
        }
        toast.error(result?.data?.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
        });
      }
    } catch (error) {
      toast.error(error?.result?.data?.errors[0], {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const api_url = process.env.REACT_APP_API_URL

  useEffect(() => {
    getPlan(idd);
  }, [idd]);

  // input hadle functions
  const handleInputChange = (index, field, value) => {
    const newInputs = [...inputs];
    newInputs[index][field] = value;
    setInputs(newInputs);
  };

  const handleFileChange = (index, field, file) => {
    const newInputs = [...inputs];
    newInputs[index][field] = file;
    setInputs(newInputs);
  };

  //handle text change
  const handleTextEditorChange = (index, content) => {
    const newInputs = [...inputs];
    newInputs[index]["text_notes"] = content;
    setInputs(newInputs);
  };

  // add new plan
  const addNewInputs = () => {
    setInputs([
      ...inputs,
      { ipr_chart: "", simulation_link_url: "", text_notes: "" },
    ]);
  };

  //remove plan
  const removeInputs = (index) => {
    const newInputs = inputs.filter((_, i) => i !== index);
    setInputs(newInputs);
  };

  useEffect(() => {
    if (caseId) {
      getCaseDetailFunction(caseId);
    }
  }, [caseId]);

  useEffect(() => {

    const baseColumns = [
      {
        name: "Plan Id",
        selector: (row) => row.planId,
        sortable: true,
      },
      {
        name: "Simulation Link",
        selector: (row) => <a className="custom-link" target="_blank" href={row.simulationLink} rel="noreferrer">View Link</a>,
        sortable: false,
      },
      {
        name: "IPR Chart File",
        selector: (row) => row.iprChart && <a className="custom-link" target="_blank" href={`${api_url}/uploads/pdf/${row.iprChart}`} rel="noreferrer">View IPR PDF</a>,
        sortable: false,
      },
      {
        name: "Actions",
        cell: (row) => (
          <>
            {permissions?.includes("case-plans-update") && (
              <div className="button-icon" onClick={() => setEditPlan(row)}>
                <FiEdit />
              </div>
            )}
            {permissions?.includes("case-plan-update") && (
              <div className="button-icon" onClick={() => navigate(`/case-detail/plan/${row.id}`)}>
                <MdEditNote title="Edit Plan" />
              </div>
            )}
            {permissions?.includes("case-plan-upload") && (
              <div className="button-icon" onClick={() => handleCasePlanUploadClick(row)}>
                <FiUpload />
              </div>
            )}
            {permissions?.includes("case-plans-detail") && (
              <div className="button-icon" onClick={() => setViewPlan(row.id)}>
                <GrView />
              </div>
            )}
            {permissions?.includes("case-plans-delete") && (
              <div
                className="button-icon"
                onClick={() => deleteCasePlanApi(row.id)}
              >
                <MdDeleteOutline />
              </div>
            )}
          </>
        ),
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
      },
    ];

    // Add additional columns for AF Case with ID 208
    if (casee?.created_user?.id === 208)
    {
      const secondLastIndex = baseColumns.length - 1; 

      const updatedColumns = [
        ...baseColumns.slice(0, secondLastIndex),
        {
          name: "Container File",
          selector: (row) => row.containerFile && <a className="custom-link" target="_blank" href={`${api_url}/uploads/container_files/${row.containerFile}`} rel="noreferrer">View Container File</a>,
          sortable: false,
        },
        {
          name: "Zip Files",
          selector: (row) => row.zipFile && <a className="custom-link" target="_blank" href={`${api_url}/uploads/zip_files/${row.zipFile}`} rel="noreferrer">View Zip File</a>,
          sortable: false,
        },
        ...baseColumns.slice(secondLastIndex)
      ];

      setPlansColumns(updatedColumns);
    } else {
      setPlansColumns(baseColumns);
    }

  }, [casee]);

  const createCasePlanApi = async () => {

    const payload = inputs?.map((input) => ({
      text_notes: input.text_notes,
      simulation_link_url: input.simulation_link_url,
    }));

    try {
      var formData = new FormData();
      if (!caseId) {
        toast.error("Case not found", {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
        });
        return;
      }

      setLoading(true);

      formData.append("p_case_id", caseId);
      formData.append("case_plans", JSON.stringify(payload));
      if (inputs) {
        inputs?.map((input, index) => (
          formData.append(`ipr_chart_files[${index}]`, input.ipr_chart)
        ));
      }

      const result = await CaseService.createCasePlan(formData);

      if (result?.data?.status === 200) {
        toast.success(result?.data?.message, {
          autoClose: 1000,
          pauseOnHover: true,
          draggable: true,
        });

        setInputs([{ ipr_chart: null, simulation_link_url: "", text_notes: "" }]);
        setCasetab("plans");
        if (caseId) {
          getCaseDetailFunction(caseId)
        }
      } else {
        toast.error(result?.data?.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
        });
      }
    } catch (error) {
      toast.error(error?.response?.data?.errors?.[0] || 'An error occurred', {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  //update plan apii
  const updateCasePlanApi = async () => {

    const payload = inputs?.map((input) => ({

      text_notes: input.text_notes,
      simulation_link_url: input.simulation_link_url,
    }));

    try {
      var formData = new FormData();
      if (!caseId) {
        toast.error("Case not found", {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
        });
        return;
      }

      setLoading(true);

      formData.append("p_case_id", caseId);
      formData.append('ipr_chart', inputs[0]?.ipr_chart)
      formData.append('simulation_link_url', inputs[0]?.simulation_link_url)
      formData.append('text_notes', inputs[0]?.text_notes)


      const result = await CaseService.updateCasePlan(idd, formData);
      if (result?.data?.status === 200) {
        toast.success(result?.data?.message, {
          autoClose: 1000,
          pauseOnHover: true,
          draggable: true,
        });

        setInputs([{ ipr_chart: null, simulation_link_url: "", text_notes: "" }]);
        setCasetab("plans");
        if (caseId) {
          getCaseDetailFunction(caseId)
        }
      } else {
        toast.error(result?.data?.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
        });
      }
    } catch (error) {
      toast.error(error?.response?.data?.errors?.[0] || 'An error occurred', {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  //delete plan apii
  const deleteCasePlanApi = async (idd) => {
    const isConfirmed = window.confirm("Are you sure you want to delete this plan?");

    if (!isConfirmed) {
      // If the user cancels, exit the function early
      return;
    }

    try {
      setLoading(true);

      const result = await CaseService.deleteCasePlan(idd);
      if (result?.data?.status === 200) {
        toast.success(result?.data?.message, {
          autoClose: 1000,
          pauseOnHover: true,
          draggable: true,
        });

        setCasetab("plans");
        if (caseId) {
          getCaseDetailFunction(caseId)
        }
      } else {
        toast.error(result?.data?.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
        });
      }
    } catch (error) {
      toast.error(error?.result?.data?.errors[0], {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="users-wrapper patinet-info mb-4">
      {loading && progress && (
        <div className="loader-parent">
          <div className="porgress-bar-custom-container">
            <div className="porgress-bar-custom-bar" style={{ width: `${progress}%` }}>
            </div>
          </div>
          <div className="textt">
            {progress}%
          </div>
        </div>
      )}
      {/* <ToastContainer /> */}

      <div className="user-details">
        <div className="tabs">
          {permissions?.includes("case-plans-list") && <div className="tab">
            <button
              className={`button ${casetab === "plans" ? "active" : ""}`}
              onClick={() => setCasetab("plans")}
            >
              All plans
            </button>
          </div>}
          {permissions?.includes("case-plans-store") && <div className="tab">
            <button
              className={`button ${casetab === "create" ? "active" : ""}`}
              onClick={() => setCasetab("create")}
            >
              Create Plan
            </button>
          </div>}
        </div>

        {/* All plans */}
        {(casetab === "plans" && permissions?.includes("case-plans-list")) &&
          <div>
            <div>
              <input
                type="file"
                accept=".zip"
                ref={casePlanUploadRef}
                onChange={handleCasePlanUpload}
                style={{ display: "none" }}
              />
              <DataTable
                columns={plansColumns}
                data={dataa}
                pagination
                paginationPerPage={10}
                paginationRowsPerPageOptions={[5, 10, 20]}
              />
            </div>
          </div>
        }
        {/* create plans */}

        {(casetab === "create" && permissions?.includes("case-plans-store")) &&
          <div>
            {inputs?.map((input, index) => (
              <div className="single-simulation" key={index}>
                {inputs.length > 1 && (
                  <div className="close" onClick={() => removeInputs(index)}>
                    <IoIosClose />
                  </div>
                )}
                <input
                  type="file"
                  className="input"
                  onChange={(e) =>
                    handleFileChange(index, "ipr_chart", e.target.files[0])
                  }
                />
                <input
                  type="text"
                  className="input"
                  value={input.simulation_link_url}
                  onChange={(e) =>
                    handleInputChange(
                      index,
                      "simulation_link_url",
                      e.target.value
                    )
                  }
                  placeholder="Simulation Link URL"
                />
                <ReactQuill
                  value={input.text_notes}
                  onChange={(content, delta, source, editor) =>
                    handleTextEditorChange(index, content)
                  }
                  placeholder="Text Notes"
                />
              </div>
            ))}
            <div className="mb-4">
              {inputs?.length > 0 && (
                <button className="button" onClick={createCasePlanApi}>
                  Submit Plan
                </button>
              )}
            </div>
            <div>
              <button className="button" onClick={addNewInputs}>
                Add More Plan
              </button>
            </div>
          </div>
        }

        {/* edit plan section */}

        {(casetab === "edit" && permissions?.includes("case-plans-update")) &&
          <div>
            {inputs?.map((input, index) => (
              <div className="single-simulation" key={index}>

                <input
                  type="file"
                  className="input"
                  onChange={(e) =>
                    handleFileChange(index, "ipr_chart", e.target.files[0])
                  }
                />
                <input
                  type="text"
                  className="input"
                  value={input.simulation_link_url}
                  onChange={(e) =>
                    handleInputChange(
                      index,
                      "simulation_link_url",
                      e.target.value
                    )
                  }
                  placeholder="Simulation Link URL"
                />
                <ReactQuill
                  value={input.text_notes}
                  onChange={(content, delta, source, editor) =>
                    handleTextEditorChange(index, content)
                  }
                  placeholder="Text Notes"
                />
              </div>
            ))}
            <div className="mb-4">
              {inputs?.length > 0 && (
                <button className="button" onClick={updateCasePlanApi}>
                  Update Plan
                </button>
              )}
            </div>

          </div>
        }

        {/* view plan section */}
        {casetab === "view" && (
          <div>
            <div className="view-box">
              <div className="title mb-3">
                Simulation link
                <span>
                  <a href={plan?.simulation_link_url} target="_blank">

                    {plan?.simulation_link_url}
                  </a>
                </span>
              </div>
              <div className="title mb-2">Text notes :</div>
              <div
                className="custom-text"
                dangerouslySetInnerHTML={{
                  __html: plan?.text_notes,
                }}
              ></div>
            </div>
            <iframe src={`${api_url}/uploads/pdf/${plan?.ipr_chart}`} width="100%" height="700px" />
          </div>
        )}
      </div>
    </div>
  );
};

export default Simulations;
